import React, { useEffect } from 'react'

import { useAppSelector } from '../common/hooks'
import { selectIdDarkTheme } from '../features/dashboard'

import { AppRoutes } from './AppRoutes/AppRoutes'
import { useIsInFrame } from './useIsInFrame'
import { useListenFrameParentMessage } from './useListenFrameParentMessage'
import { useRouteChangeReporter } from './useRouteChangeReporter'

function App() {
  const isDarkTheme = useAppSelector(selectIdDarkTheme)

  useRouteChangeReporter()
  useIsInFrame()
  useListenFrameParentMessage()

  useEffect(() => {
    document.body.classList.toggle('dark-mode', isDarkTheme)
  }, [isDarkTheme])

  return (
    <div className="App">
      <AppRoutes />
    </div>
  )
}

export default App
